import React from "react";
import $ from "jquery";

const Tooltip = ({ text }) => {
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  return (
    <span data-toggle="tooltip" title={text}>
      &nbsp;
      <i className="fas fa-info-circle text-secondary"></i>
    </span>
  );
};

export default Tooltip;
